import { FC } from 'react';

interface Props {
    description: string;
}

const DiscardChangesContent: FC<Props> = ({ description }) => {
    return <div className="text-13 text-gray-800 font-sf whitespace-normal">{description}</div>;
};

export default DiscardChangesContent;
